import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { useEventInfo } from '@shared/utils/eventInfo';
import { useGetRsvpDeadlineQuery } from '../../components/CtaButtons/RsvpDeadline.graphql.generated';

/**
 * Single source of truth for RSVP deadline gating across guest surfaces.
 * Uses the same cached Apollo query as CtaButtons, so no extra network requests.
 */
export const useRsvpDeadlineGuard = () => {
  const [isRsvpDeadlineEnabled] = useIsFeatureEnabled('rsvpDeadlineEnabled');
  const { eventInfo } = useEventInfo();
  const eventId = eventInfo?.eventId;

  const { data: deadlineData } = useGetRsvpDeadlineQuery({
    variables: { eventId: eventId || '' },
    batchMode: 'fast',
    skip: !eventId || !isRsvpDeadlineEnabled,
    ssr: false,
  });

  const rsvpDeadline = deadlineData?.getRsvpSettingsByEventId;
  const isRsvpClosedByDeadline = isRsvpDeadlineEnabled && rsvpDeadline?.isOpen === false;
  const showDeadlineToGuest = isRsvpDeadlineEnabled && rsvpDeadline?.showDeadline === true && rsvpDeadline?.deadlineDate != null;
  const deadlineDate = rsvpDeadline?.deadlineDate ?? null;

  return { isRsvpClosedByDeadline, showDeadlineToGuest, deadlineDate };
};
